import { render, staticRenderFns } from "./CreateSttConfiguration.vue?vue&type=template&id=2f9aec6c&scoped=true&"
import script from "./CreateSttConfiguration.vue?vue&type=script&lang=js&"
export * from "./CreateSttConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./CreateSttConfiguration.vue?vue&type=style&index=0&id=2f9aec6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9aec6c",
  null
  
)

export default component.exports